module.exports = __webpack_public_path__ + "static/media/stripe-badge-white.ebd454c4.svg";